import './views/edit'
import './views/new'
import './views/show'
